import { useParams } from 'react-router-dom'
import { AlertCircle } from 'lucide-react'
import { usePortalCliente } from '@/hooks/usePortalCliente'
import { PortalClienteContent } from '@/components/PortalCliente/PortalClienteContent'

export default function PortalCliente() {
  const { token } = useParams<{ token: string }>()
  const portal = usePortalCliente(token)

  if (portal.loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-accent/30 border-t-accent rounded-full animate-spin" />
      </div>
    )
  }

  if (portal.error || !portal.data) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
        <div className="text-center space-y-4">
          <AlertCircle size={48} className="text-red-400 mx-auto" />
          <h1 className="text-xl font-bold text-white">{portal.error ?? 'Erro'}</h1>
          <p className="text-white/50">Verifique se o link está correto.</p>
        </div>
      </div>
    )
  }

  return <PortalClienteContent portal={portal} />
}
